import { FormattedMessage } from 'react-intl';
import { Divider } from '@mui/material';
import { Button } from '@atoms/buttons';
import { Flex } from '@atoms/layout';

type PeriodicShiftDrawerControlsProps = {
  hide?: boolean;
  onClose?: () => void;
};
export function PeriodicShiftDrawerControls({ hide, onClose }: PeriodicShiftDrawerControlsProps) {
  return (
    <Flex
      column
      position="sticky"
      bottom={0}
      height={hide ? '0' : '70px'}
      overflow="hidden"
      sx={{ transition: 'height 0.3s' }}
    >
      <Divider />
      <Flex gap={2} justifyContent="space-between" p={2} bgcolor={'background.paper'}>
        <Flex>
          <Button variant="passive" onClick={onClose}>
            <FormattedMessage id="common.back" />
          </Button>
        </Flex>
      </Flex>
    </Flex>
  );
}
